import React, { useMemo } from 'react';
import { STYLES, getStatusBadgeStyle, getTableRowStyle } from './styles.js';
import DownloadButton from '../../../../components/Buttons/DownloadButton.jsx';

/**
 * Componente para mostrar el badge de estado
 */
const StatusBadge = ({ status }) => (
  <span style={getStatusBadgeStyle(status)}>
    {status}
  </span>
);

/**
 * Componente para una fila de la tabla
 */
const TableRow = React.memo(({ journal, index }) => (
  <tr style={getTableRowStyle(index)}>
    <td style={STYLES.tableCellMono}>{journal.id}</td>
    <td style={STYLES.tableCellMono}>{journal.journal_id}</td>
    <td style={STYLES.tableCellMono}>{journal.batch_id}</td>
    <td style={STYLES.tableCell}>
      <StatusBadge status={journal.status} />
    </td>
    <td style={{
      ...STYLES.tableCell,
      maxWidth: '300px',
      wordWrap: 'break-word',
    }}>
      {journal.reason || '-'}
    </td>
    <td style={{
      ...STYLES.tableCell,
      whiteSpace: 'nowrap',
    }}>
      {new Date(journal.created_at).toLocaleString()}
    </td>
    <td style={{
      ...STYLES.tableCell,
      whiteSpace: 'nowrap',
    }}>
      {new Date(journal.updated_at).toLocaleString()}
    </td>
  </tr>
));

TableRow.displayName = 'TableRow';

/**
 * Componente principal de la tabla
 */
export const JournalsTable = ({ 
  journals, 
  onDownloadCsv, 
  downloadingCsv 
}) => {
  const tableRows = useMemo(() => 
    journals.map((journal, index) => (
      <TableRow 
        key={journal.id} 
        journal={journal} 
        index={index} 
      />
    )), [journals]
  );

  return (
    <div>
      <div style={STYLES.tableHeader}>
        <h3>Journals encontrados ({journals.length})</h3>
        <DownloadButton
          onClick={onDownloadCsv}
          disabled={downloadingCsv}
          text={downloadingCsv ? 'Descargando...' : 'Descargar CSV'}
        />
      </div>
      
      <div style={STYLES.tableContainer}>
        <table style={STYLES.table}>
          <thead>
            <tr>
              <th style={STYLES.tableHeaderCell}>ID</th>
              <th style={STYLES.tableHeaderCell}>Journal ID</th>
              <th style={STYLES.tableHeaderCell}>Batch ID</th>
              <th style={STYLES.tableHeaderCell}>Status</th>
              <th style={STYLES.tableHeaderCell}>Razón</th>
              <th style={STYLES.tableHeaderCell}>Creado</th>
              <th style={STYLES.tableHeaderCell}>Actualizado</th>
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/**
 * Componente para mostrar el estado vacío
 */
export const EmptyState = () => (
  <div style={STYLES.emptyState}>
    <p>No se encontraron journals para los criterios especificados.</p>
  </div>
);
